import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { MarketplaceAPI } from "../infrastructure/api/Marketplace.api";
import { MarketplaceFilters } from "../domain/types";

const MARKETPLACE_KEY = "marketplace-tools";
const ADOPTED_KEY = "marketplace-adopted";

export const useTools = (filters: MarketplaceFilters) => {
    return useQuery({
        queryKey: [MARKETPLACE_KEY, filters],
        queryFn: async () => {
            const { data } = await MarketplaceAPI.list(filters);
            return data;
        },
    });
};

export const useToolDetail = (slug: string) => {
    return useQuery({
        queryKey: [MARKETPLACE_KEY, "detail", slug],
        queryFn: async () => {
            const { data } = await MarketplaceAPI.detail(slug);
            return data;
        },
        enabled: Boolean(slug),
    });
};

export const useAdoptedTools = () => {
    return useQuery({
        queryKey: [ADOPTED_KEY],
        queryFn: async () => {
            const { data } = await MarketplaceAPI.listAdopted();
            return data;
        },
    });
};

const invalidate = (queryClient: ReturnType<typeof useQueryClient>) => {
    queryClient.invalidateQueries({ queryKey: [MARKETPLACE_KEY] });
    queryClient.invalidateQueries({ queryKey: [ADOPTED_KEY] });
};

export const useAdoptTool = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (toolId: string) => MarketplaceAPI.adopt(toolId),
        // Settled, not only success: a refusal because the centre switched the
        // tool off since the catalogue loaded should bring that notice up.
        onSettled: () => invalidate(queryClient),
    });
};

export const useRemoveTool = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (toolId: string) => MarketplaceAPI.remove(toolId),
        onSuccess: () => invalidate(queryClient),
    });
};
